import { request } from './request';

export const getAllInvoices = (page = 1, queryString = '') =>
  request(`invoices?page=${page}${queryString}&limit=50`);

export const getInvoiceById = (id) => request(`invoices/${id}`);

export const getInvoiceUrlById = (id) => request(`invoices/${id}/url`);

export const getAccountUrl = () => request(`invoices/account-url`);

export const createAccount = (body) =>
  request(`invoices/account`, {
    method: 'POST',
    body,
  });

export const createInvoice = (body) =>
  request(`invoices`, {
    method: 'POST',
    body,
  });
